import { isCustomizedType, reduce } from "et3-type-guards";
import { Ti18nKeys } from "../../constants/i18n";

import i18nServerResponse from "../../constants/i18n-server-response";
import { post } from "../axios-post";

export const apiCallUpdateAuditAdminEvents = async ({
  adminId,
  issueType,
  eventID,
  type,
  reason_ids,
  proof
}: {
  adminId: number;
  issueType: "minor" | "major" | "no_issue";
  eventID: number;
  type: string;
  reason_ids: number[];
  proof: string;
}): Promise<{
  data: Object;
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post(
    `auditor/updateAuditAdminEvent`,
    {
      adminId,
      issueType,
      eventID,
      type,
      reason_ids,
      proof
    }
  );

  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: { eventsList: [], eventsCount: [], totalEvents: 0 },
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: { eventsList: [], eventsCount: [], totalEvents: 0 },
      status: "ERROR",
      code: "ERROR"
    };
  }
};
